The identifier for the draft that the `PositionProfile` is to be previewed from.
